import React, { useState } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import { supabase } from '../supabaseClient';
import './ProfessorLogin.css';
import BrowserRecommendation from '../components/BrowserRecommendation';

function ProfessorLogin() {
  const [email, setEmail] = useState('');
  const [motDePasse, setMotDePasse] = useState('');
  const [erreur, setErreur] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const navigate = useNavigate();

  const handleLogin = async (e) => {
    e.preventDefault();
    setErreur('');
    setIsLoading(true);

    const { data, error } = await supabase.auth.signInWithPassword({
      email,
      password: motDePasse,
    });

    setIsLoading(false);

    if (error) {
      setErreur("Email ou mot de passe incorrect");
    } else {
      // Vérifier que c'est bien un professeur
      const userRole = data?.user?.user_metadata?.role;
      
      console.log('Utilisateur connecté:', data.user.email);
      console.log('Rôle détecté:', userRole);
      
      if (userRole === 'prof') {
        console.log('Redirection vers dashboard professeur');
        navigate('/prof-dashboard');
      } else {
        setErreur("Vous êtes étudiant. Veuillez utiliser la page de connexion étudiants.");
        await supabase.auth.signOut();
      }
    }
  };

  return (
    <div className="professor-login-container">
     <BrowserRecommendation variant="banner" /> 
      {/* Lettres arabes décoratives en arrière-plan */}
      <div className="professor-arabic-background">
        <div className="professor-arabic-letter letter-1">م</div>
        <div className="professor-arabic-letter letter-2">د</div>
        <div className="professor-arabic-letter letter-3">ر</div>
      </div>

      {/* Bouton retour */}
      <button onClick={() => navigate('/')} className="prof-back-button">
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M10 19l-7-7m0 0l7-7m-7 7h18" />
        </svg>
        Retour
      </button>

      {/* Carte de connexion */}
      <div className="professor-login-card">
        <div className="professor-login-header">
          <div className="professor-icon">
            <svg
              width="64"
              height="64"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            >
              <path d="M12 6.253v13m0-13C10.832 5.477 9.246 5 7.5 5S4.168 5.477 3 6.253v13C4.168 18.477 5.754 18 7.5 18s3.332.477 4.5 1.253m0-13C13.168 5.477 14.754 5 16.5 5c1.747 0 3.332.477 4.5 1.253v13C19.832 18.477 18.247 18 16.5 18c-1.746 0-3.332.477-4.5 1.253"></path>
            </svg>
          </div>
          <h2 className="professor-title">Espace Professeur</h2>
          <p className="professor-subtitle">معلم</p>
          <p className="professor-description">Connectez-vous pour gérer vos cours</p>
        </div>

        <form onSubmit={handleLogin} className="professor-login-form">
          <div className="professor-form-group">
            <label htmlFor="email">Email</label>
            <input
              id="email"
              type="email"
              placeholder="votre@email.com"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
              className="professor-input-field"
            />
          </div>

          <div className="professor-form-group">
            <label htmlFor="password">Mot de passe</label>
            <input
              id="password"
              type="password"
              placeholder="••••••••"
              value={motDePasse}
              onChange={(e) => setMotDePasse(e.target.value)}
              required
              className="professor-input-field"
            />
          </div>

          {erreur && <div className="professor-error-message">{erreur}</div>}

          <button type="submit" className="professor-login-button" disabled={isLoading}>
            {isLoading ? (
              <span className="professor-spinner"></span>
            ) : (
              "Se connecter"
            )}
          </button>
        </form>

        <div className="professor-login-footer">
          <Link to="/forgot-password" className="professor-forgot-password">
            Mot de passe oublié ?
          </Link>
          <p className="professor-register-link">
            Pas encore inscrit comme professeur ? <Link to="/register?role=professor">S'inscrire</Link>
          </p>
          <div className="professor-divider">
            <span>ou</span>
          </div>
          <Link to="/login" className="professor-switch-link">
            Vous êtes étudiant ? Connectez-vous ici
          </Link>
        </div>
      </div>
    </div>
  );
}

export default ProfessorLogin;
